import { sharedEnvironment } from '@vinnova/environments';

export const environment = {
  production: sharedEnvironment.acc.production,
  name: sharedEnvironment.acc.name,
  forhandsgranskaUrl: sharedEnvironment.acc.forhandsgranskaUrl,
  bpUrl: sharedEnvironment.acc.bpUrl,
  etjansterCommonUrl: sharedEnvironment.acc.etjansterCommonUrl,
  cookieDomain: sharedEnvironment.acc.cookieDomain,
  forhandsgranskaApiUrl: `${sharedEnvironment.acc.forhandsgranskaApiUrl}`,
  etjansterCommonApiUrl: `${sharedEnvironment.acc.gatewayUrl}/etjanster`,
  resourceStringUrl: `${sharedEnvironment.acc.gatewayUrl}/resourcestring/forhandsgranska`,
  sprakHanteringApiUrl: `${sharedEnvironment.acc.gatewayUrl}/resourcestring`,
  oregApiUrl: `${sharedEnvironment.acc.gatewayUrl}/organisationsregistret`,
  logServiceApiUrl: `${sharedEnvironment.acc.gatewayUrl}/logger`,
  projektUrl: sharedEnvironment.acc.projektUrl,
  externalLinks: sharedEnvironment.acc.externalLinks,
  baseGatewayUrl: sharedEnvironment.acc.gatewayUrl,
  apimSubscriptionKey: sharedEnvironment.acc.apimSubscriptionKey,
  msalConfig: {
    ...sharedEnvironment.msalConfig(
      sharedEnvironment.acc.forhandsgranskaApiUrl,
      'bbbd52ff-db6f-4f8f-9811-9b4dd34b7c62',
      '622b10a2-70cb-4926-b99c-f9862c520932',
      sharedEnvironment.acc.forhandsgranskaUrl,
    ),
    allowRedirectInIframe: true,
  },
  effektaArendekortUrl: `${sharedEnvironment.acc.effektaUrl}/Platina/modules/customized/navigera/arende.aspx`,
};
